import { useQuery } from '@tanstack/react-query'
import { soundscapesQueryOptions } from '@/entities/soundscape'
import { Button } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { focusStart } from '../lib/catalog'
import { useSoundscapePlayer } from '../model/player-store'
import { useResumePlay } from '../model/use-resume-play'

// Вход в фокус прямо с задачи: звук включается на месте, без захода на консоль
// фокуса. Возвращается последний слушанный режим — под что человек работал, под
// то и продолжит; в первый раз это режим модальности focus.
export function FocusMusicButton() {
  const { data } = useQuery(soundscapesQueryOptions)
  const { playing, loading, lastSlug, title, stop } = useSoundscapePlayer()
  const resume = useResumePlay()

  const target = focusStart(data ?? [], lastSlug)
  if (!target) return null

  return (
    <Button
      variant="secondary"
      disabled={loading}
      onClick={() => {
        if (playing) stop()
        else resume.play(target.slug, target.title)
      }}
      title={`Режим «${playing ? title : target.title}»`}
    >
      <Icon name="music" size={16} />
      {playing ? 'Выключить музыку для концентрации' : 'Включить музыку для концентрации'}
    </Button>
  )
}
